import React, { useState } from 'react'
import CollectionPointsContainer from './container'
import FoodCategoriesModal from 'components/Modal/FoodCategories/FoodCategoriesModal';
import ConfirmationDialog from 'components/Modal/ConfirmationDialog/ConfirmationDialog';
import { useAddCollectionPointsMutation, useChangeStatusCollectionPointsMutation, useDeleteCollectionPointsMutation, useGetCollectionPointsQuery, useUpdateCollectionPointsMutation } from './services';
import CollectionPointsModal from 'components/Modal/CollectionPoints/CollectionPoints';

const CollectionPoints = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [open, setOpen] = useState(false);
    const [editingPoints, setEditingPoints] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [delData, setDelData] = useState(false);
    const [togglingCollectionId, setTogglingCollectionId] = useState(null);

    const { data: collectionData, isLoading, isError } = useGetCollectionPointsQuery();

    const [addCollections, { isLoading: adding }] = useAddCollectionPointsMutation();
    const [updateCollections, { isLoading: updating }] = useUpdateCollectionPointsMutation();
    const [deleteCollections, {isLoading: isDeleteLoading}] = useDeleteCollectionPointsMutation();
    const [changeStatusCollections, {isLoading: isChangeStatusLoading}] = useChangeStatusCollectionPointsMutation();

    const filteredItems = collectionData?.data?.records?.filter(cat =>
      cat.name.toLowerCase().includes(searchQuery.trim().toLowerCase())
    ) ?? [];


    const handleAddBtn = () => {
        setEditingPoints(null);
        setOpen(true);
    };

    const handleEdit = (point) => {
        setEditingPoints(point);
        setOpen(true);
    };
    
    const handleDelete = (point) => {
        setConfirmDialogOpen(true);
        setDelData(point);
    }

    const handleToggle = async (point) => {
        setTogglingCollectionId(point.id);
        try {
            const toggleRes =  await changeStatusCollections({
                id: point.id,
                body: !point.active_status
            })
        } catch (err) {
            console.error('Failed to change status', err);
        } finally {
          setTogglingCollectionId(null);
        }
    }

    const handleClose = () => {
        setOpen(false);
        setEditingPoints(null);
    };

    const handleSubmit = async (values, { setSubmitting, setErrors }) => {
        try {
        if (editingPoints) {
            await updateCollections({ id: editingPoints.id, ...values }).unwrap();
        } else {
            await addCollections(values).unwrap();
        }
        handleClose();
        } catch (error) {
        setErrors(error.data?.errors || {});
        } finally {
        setSubmitting(false);
        }
    };

    const handleConfirmDelete = async () => {
        try{
            const deleteResponse = await deleteCollections(delData?.id);
            setConfirmDialogOpen(false);
        } catch(error) {
            console.log(error, "Error in Delete collection")
        }
    }

  return (
    <>  
    <CollectionPointsContainer
        collectionPointItem={filteredItems}
        loading={isLoading}
        error={isError}
        searchTxt={searchQuery}
        setSearchQuery={setSearchQuery}
        handleAddBtn={handleAddBtn}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handleToggle={handleToggle}
        togglingCollectionId={togglingCollectionId}
    />

    <CollectionPointsModal
        open={open}
        onClose={handleClose}
        initialData={editingPoints}
        onSubmit={handleSubmit}
        loading={adding || updating}
    />

    <ConfirmationDialog
        open={confirmDialogOpen}
        handleClose={() => setConfirmDialogOpen(false)}
        handleConfirm={handleConfirmDelete}
        btnText="Delete"
        infoText={`Are you sure you want to delete this ${delData?.name}?`}
        isLoading={isDeleteLoading}
        action={"Delete"}
    />
    </>
  )
}

export default CollectionPoints
